import { getPriceString } from "@app/utils/localeUtils"
import { useSelector } from "@tecreation/js-state-react"

export default function MyParadiseEmployeePoints() {
	const relation = useSelector("core.relation")
	const employeePoints = relation?.employeePoints

	const points = employeePoints ? getPriceString(employeePoints.amount, 2).replace("€", "") : "-"

	return (
		<div className="color-bg-secondary-100 h-100 w-100 flex flex-center">
			<div className="text-center">
				<div className="f0 ">{points}</div>
				<div>Mitarbeiterunkte</div>
			</div>
		</div>
	)
}
